import { Model } from '@/models/Model'
import Property from '@/decorators/Property'

export class CargoHoldFloor extends Model {
	protected jsonApiType = 'cargoHoldFloorTypes'

	@Property()
	public title!: string

	@Property()
	public sequence!: number

	public static async fetchAllLazy(): Promise<Array<CargoHoldFloor>> {
		const store = (await import('@/store/index')).store
		if (!store.getters['cargoHoldFloors/hasAllFetched']()) {
			await store.dispatch('cargoHoldFloors/findAll')
		}

		return store.getters['cargoHoldFloors/peekAll']()
	}

	public static async fetchLazy(id): Promise<CargoHoldFloor> {
		const store = (await import('@/store/index')).store
		if (!store.getters['cargoHoldFloors/hasCached'](id)) {
			await store.dispatch('cargoHoldFloors/findRecord', id)
		}

		return store.getters['cargoHoldFloors/peekRecord'](id)
	}
}
